import getI18nProps from '@/utils/i18/getI18nProps';
import RingGame from '@/components/features/casino/ring';
import CatchError from '@/components/system/CacthError';

// export const runtime = 'experimental-edge';
export function CasinoCrash() {
  return <RingGame />;
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await getI18nProps({ locale })),
    },
  };
}

export default CatchError(CasinoCrash);
